<template>
  <div class="min-h-screen flex flex-col">
    <BlackFridayBanner />

    <div class="flex-1 flex items-center justify-center p-4">
      <div class="max-w-4xl w-full">
        <GenderHeader />

        <div class="grid grid-cols-2 gap-4 mb-6 mx-auto max-w-[520px]">
          <QuickQuizText class="col-span-2" />

          <!-- Gender Buttons -->
          <div class="gender-buttons grid grid-cols-2 gap-4 col-span-2">
            <GenderButton
              :image="genderImages.male"
              :label="genderLabels.male"
              :is-selected="selectedGender === 'male'"
              @select="handleGenderSelect('male')"
            />

            <GenderButton
              :image="genderImages.female"
              :label="genderLabels.female"
              :is-selected="selectedGender === 'female'"
              @select="handleGenderSelect('female')"
            />
          </div>
        </div>

        <TermsText />
      </div>
    </div>

    <LegalFooter />
  </div>
</template>

<script setup lang="ts">
import BlackFridayBanner from '../../../BlackFridayBanner.vue'
import LegalFooter from '../../../LegalFooter.vue'
import GenderHeader from './components/GenderHeader.vue'
import QuickQuizText from './components/QuickQuizText.vue'
import GenderButton from './components/GenderButton.vue'
import TermsText from './components/TermsText.vue'
import { useGenderSelection } from './composables/useGenderSelection'

const emit = defineEmits(['gender-selected'])

const {
  selectedGender,
  genderImages,
  genderLabels,
  selectGender
} = useGenderSelection()

const handleGenderSelect = (gender: 'male' | 'female') => {
  selectGender(gender)
  emit('gender-selected', gender)
}
</script>